<template>
    <div id="helpOverlay" class="overlay">
      <div id="helpModal" class="modal" v-click-outside="toggleHelpModal">
        <div class="modal-header">
          <div id="helpHeader">HELP</div>
        </div>
        <div id="helpContent" class="modal-content">
          <div class="help-entry">
            <div class="help-subheader">How do I increase my rank?</div>
            <div class="help-answer">
              Scoring is as follows:
              <ul class="help-list">
                <li><b>Correct Answer</b>: Each question has a point value.  The faster you answer, the more points you receive.</li>
                <li><b>Incorrect Answer</b>: Your score remains unchanged</li>
                <li><b>Time Expires</b>: Your score remains unchanged</li>
              </ul>
            </div>
          </div>
          <div class="help-entry">
            <div class="help-subheader">What devices can I use for this quiz?</div>
            <div class="help-answer">You may use a desktop computer, laptop, iPad, or mobile phone.</div>
          </div>
          <div class="help-entry">
            <div class="help-subheader">How long is this quiz?</div>
            <div class="help-answer">Each round of the quiz has 5 questions and should take under 5 minutes to complete. Each question has a {{ questionTime }} second time limit.</div>
          </div>
          <div class="help-entry">
            <div class="help-subheader">Can I pause the quiz?</div>
            <div class="help-answer">
              The quiz pauses between questions. However, if you leave the quiz during a question, you will not earn points for that question.
            </div>
          </div>
          <div class="help-entry">
            <div class="help-subheader">Can I retake this quiz?</div>
            <div class="help-answer">
              You may not retake this quiz.
            </div>
          </div>
          <div class="help-callout">Please ensure that you have a stable Internet connection before beginning the quiz.</div>
        </div>
      </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'HelpModal',
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'questionTime',
    ]),
  },
  methods: {
    ...mapActions([
      'toggleHelpModal'
    ]),
  },
  mounted(){

  },
  beforeUnmount(){

  },
  data: function(){
    return {

    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>

<style>
  #helpOverlay{

  }

  #helpModal{

  }

  #helpContent{
    text-align: left;
    padding: 10px 20px;
  }

  .help-entry{
    margin: 10px 0px;
  }

  .help-subheader{
    font-size: 22px;
    font-weight: bold;
  }

  .help-question{

  }

  .help-callout{
    font-size: 13px;
    font-weight: bold;
    text-align: center;
  }

  .help-list{
    text-align: left;
    margin: 0px;
    padding-left: 25px;
  }
</style>